import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiModels, HttpService } from '@mona/api';
import { Patient, TherapyLimitations } from '@mona/models';
import { transformApiTherapyLimitations } from '@mona/pdms/data-access-encounter-data';

/**
 * API abstraction layer for the therapy limitations API
 */
@Injectable({
    providedIn: 'root',
})
export class TherapyLimitationsApi {
    apiBase = '/pdms/therapy-limitations/';

    /**
     * Constructor
     *
     * @param http HttpClient
     */
    constructor(private http: HttpService) {}

    /**
     * Get therapy limitations
     *
     * @param patientId EntityId<Patient>
     */
    getTherapyLimitations(patientId?: EntityId<Patient>): Observable<TherapyLimitations[]> {
        const params: { [param: string]: string | string[] } = {};

        if (patientId) {
            params.patient_id = `${patientId}`;
        }

        return this.http
            .get<ApiModels.TherapyLimitations[]>(this.apiBase, { params })
            .pipe(map(therapyLimitations => transformApiTherapyLimitations(therapyLimitations)));
    }
}
